<script setup lang="ts">
import type { TIconColor } from '@/shared/mm-ui-kit';
import { computed } from 'vue';

const CLASS_PREFIX = 'mm-icon';

const props = defineProps<{
  colors?: Array<string>;
  color?: TIconColor;
  size?: number;
}>();

const normalizedColors = computed(() => {
  /** распознаем css-токены */
  return props.colors?.map((color) => (color.startsWith('--') ? `var(${color})` : color));
});

const colorClass = computed(() => (props.color ? `${CLASS_PREFIX}_${props.color}` : ''));

const iconStyleObj = computed(() => {
  return {
    height: props.size ? `${props.size}px` : '1em',
    minWidth: props.size ? `${props.size}px` : '1em',
  };
});
</script>

<template>
  <i class="icon" :class="colorClass" :style="iconStyleObj"><slot :colors="normalizedColors" /></i>
</template>

<style lang="stylus" scoped>
@require '../styles/colors.styl'
.icon
  display inline-flex
</style>
